import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { TerminListAdminFilter } from '../../../../../../model/TerminListAdminFilter';
import { SafeParameterSetter } from '../../../../../../model/SafeParameterSetter';

interface Props {
  filter: TerminListAdminFilter;
  onUpdateField: SafeParameterSetter<TerminListAdminFilter>;
  className?: string;
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void;
}

const FilterTagsComponent = ({
  filter, onUpdateField, className, onClearFilters = null,
}: Props): ReactElement => {
  const classes: string = classNames('tezaury-filter-tag-component', className);
  return (
    <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
      <FilterTag
        title="Hľadaný termín"
        data={filter.hladanyTermin}
        onClear={() => {
          onUpdateField('hladanyTermin', '');
        }}
      />
      <FilterTag
        title="Stav publikácie"
        data={getPublikovany(filter.publikovany)}
        onClear={() => {
          onUpdateField('publikovany', undefined);
        }}
      />
      <FilterTag
        title="Autor poslednej zmeny"
        data={filter.autorPoslednejZmeny?.nazov}
        onClear={() => {
          onUpdateField('autorPoslednejZmeny', undefined);
        }}
      />
    </FilterTagGroup>
  );
};

function getPublikovany(publikovany: boolean | undefined): string {
  switch (publikovany) {
    case true: return 'Publikované';
    case false: return 'Nepublikované';
    default: return undefined;
  }
}

export default FilterTagsComponent;
